<template>
    <div class="tc-modal-unsaved-case-alert tc-modal-body">
        <div class="tc-modal-label">
            Создать новый шкаф
        </div>
        <div class="tc-modal-text">
            Вы собираетесь Создать новый шкаф в проекте "Мой проект 1". Все несохраненные изменения этой сцены будут утеряны.
        </div>
        <OrangeButtonOfLawlessness :text="'Сохранить и перейти к новому шкафу'"
                                   @click="saveAndNext()"/>
        <OutlineButton :text="'Не сохранять изменения, перейти к новому шкафу'"
                       @click="dontSaveAndNext()"/>
        <div class="tc-borderline-horizontal"></div>
        <OutlineButton :text="'Вернуться к редактированию'"
                       @click="cancel()"/>
    </div>
</template>

<script>
import OrangeButtonOfLawlessness from '@/UI/CommonComponents/OrangeButtonOfLawlessness.vue';
import OutlineButton from '@/UI/CommonComponents/OutlineButton.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { onStoreUpdateHandler } from '@/Engine/eventHandlers/onStoreUpdate';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { saveCase } from '@/libs/saveCase';

export default {
    name: 'ModalUnsavedCaseAlert',
    components: {
        OutlineButton,
        OrangeButtonOfLawlessness,
    },
    setup() {
        const storeUI = useStoreUI();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storeProjectStructure = useStoreProjectStructure();
        return {
            storeUI,
            storeCaseConfiguration,
            storeProjectStructure,
        };
    },
    methods: {
        saveAndNext() {
            saveCase();
            this.storeUI.setActiveModalName('newCaseTypeSelect');
        },
        dontSaveAndNext() {
            const previousConfiguration = this.storeProjectStructure.getSelectedCaseData;

            if (previousConfiguration) {
                this.storeCaseConfiguration.$patch(previousConfiguration);
            }

            onStoreUpdateHandler();
            this.storeUI.setActiveModalName('newCaseTypeSelect');
        },
        cancel() {
            this.storeUI.setIsShowModal(false);
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/modal";

.tc-modal-unsaved-case-alert {
    width: 475px;
}

</style>
